
import ConfigScene from '../helpers/ConfigScene';
import BgSky from './components/BgSky';
import Town from './town/Town';
import Transition from './transition/Transition';
import Heaven from './heaven/Heaven';
import TownSnow from './components/TownSnow';

class SceneCont extends PIXI.Container {
  constructor() {
    super();

    // move vars
    this.difference = {
      x: 0,
      y: 0,
    };

    // parts
    this.sky = null;
    this.heaven = null;
    this.transition = null;
    this.town = null;
    this.townSnow = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // parts
    this.setParts();

    // listeners
    aScene.signals.pxRescall.add(this.resUp, this);
    aScene.signals.loopCall.add(this.loopUp, this);
  }

  // --------------------------------------------------------------
  // Parts
  // --------------------------------------------------------------

  setParts() {
    this.sky = new BgSky();
    this.addChild(this.sky);

    this.heaven = new Heaven();
    this.addChild(this.heaven);

    this.transition = new Transition();
    this.addChild(this.transition);

    this.town = new Town();
    this.addChild(this.town);

    this.townSnow = new TownSnow(this);
  }

  // --------------------------------------------------------------
  // Resize
  // --------------------------------------------------------------

  resUp() {
    this.scale.x = aPage.resizer.scaleMain;
    this.scale.y = aPage.resizer.scaleMain;
    this.difference.x = ConfigScene.DIFF_X * aPage.resizer.scaleMain;
    this.difference.y = ConfigScene.DIFF_Y * aPage.resizer.scaleMain;
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    this.x =
      -(aPage.resizer.canvasDiffX * 0.5) -
      (this.difference.x * aScene.iManager.stageRatio.x);
    this.y =
      (aScene.sceneManager.offset * aPage.resizer.scaleMain) -
      (aPage.resizer.canvasDiffY * 0.5) -
      (this.difference.y * aScene.iManager.stageRatio.y);
  }
}

export default SceneCont;



// WEBPACK FOOTER //
// ./src/js/scene/parts/SceneCont.js